<template>
    <div class="switch" v-if="'gz' in options[value]">
        <div class="label item">
            {{ options[value].gz.label }}
        </div>
        <div class="selector">
            <div class="item" 
              v-for="(item, index) in options" :key="index"
              @click="$emit('input', index)">
              {{ item.gz.label }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: ['value', 'options']
}
</script>

<style scoped lang="stylus">
.switch
    position absolute
    top 0.6rem
    right 0.6rem
    background-color white
    display flex
    flex-direction column
    .label
        font-weight bold
        position relative
    &:hover > .selector
        display block
    .selector
        display none
    .item
        padding 0.5rem
        background-color white
        text-align center
        min-width 100px
        &:hover
            background-color lightgrey
            cursor pointer
</style>



// WEBPACK FOOTER //
// src/components/CockpitSwitch.vue